<mat-accordion class="application-menu-accordion">
    @if (isSuperAdmin) {
        <mat-expansion-panel hideToggle>
            <mat-expansion-panel-header class="">Général</mat-expansion-panel-header>
            <div class="application-menu">
                <a
                    class="application-menu-item"
                    matTooltip="Définitions des Paramètres"
                    matTooltipPosition="right"
                    routerLink="/parameters"
                    [ngClass]="{ 'mat-list-item-visited': router.url === '/parameters' }">
                    <fa-icon [icon]="faParameters" class="fa-icon parameters-fa-icon menu-icon" [ngClass]="{ visited: router.url === '/parameters' }"></fa-icon>
                    <span class="menu-text">Définitions des Paramètres</span>
                </a>
                <a
                    class="application-menu-item"
                    matTooltip="Supervision des logs"
                    matTooltipPosition="right"
                    routerLink="/log-supervision"
                    [ngClass]="{ 'mat-list-item-visited': router.url === '/log-supervision' }">
                    <fa-icon [icon]="faLogs" class="fa-icon parameters-fa-icon menu-icon" [ngClass]="{ visited: router.url === '/log-supervision' }"></fa-icon>
                    <span class="menu-text">Supervision des logs</span>
                </a>
                <a
                    class="application-menu-item"
                    matTooltip="Logs connecteur mail"
                    matTooltipPosition="right"
                    routerLink="/log-mail-connector"
                    [ngClass]="{ 'mat-list-item-visited': router.url === '/log-mail-connector' }">
                    <fa-icon [icon]="faConnectorLogs" class="fa-icon parameters-fa-icon menu-icon" [ngClass]="{ visited: router.url === '/log-mail-connector' }"></fa-icon>
                    <span class="menu-text">Logs connecteur mail</span>
                </a>
            </div>
        </mat-expansion-panel>
    }
    <mat-expansion-panel hideToggle>
        <mat-expansion-panel-header class="">Organisation courante</mat-expansion-panel-header>
        <div class="application-menu">
            @if (displaySubscriptionsMenu) {
                <a
                    class="application-menu-item"
                    matTooltip="Abonnements de l'organisation"
                    matTooltipPosition="right"
                    routerLink="/organization/subscriptions"
                    [ngClass]="{ 'mat-list-item-visited': router.url === '/organization/subscriptions', disabled: !isOrganizationSelected }">
                    <fa-icon [icon]="faSubscriptions" class="fa-icon menu-icon" [ngClass]="{ visited: router.url === '/organization/subscriptions' }"></fa-icon>
                    <span class="menu-text">Abonnements</span>
                </a>
            }
            @if (displayParametersMenu) {
                <a
                    class="application-menu-item"
                    matTooltip="Paramètres de l'organisation"
                    matTooltipPosition="right"
                    routerLink="/organization/parameters"
                    [ngClass]="{ 'mat-list-item-visited': router.url === '/organization/parameters', disabled: !isOrganizationSelected }">
                    <fa-icon [icon]="faParameters" class="fa-icon parameters-fa-icon menu-icon" [ngClass]="{ visited: router.url === '/organization/parameters' }"></fa-icon>
                    <span class="menu-text">Paramètres</span>
                </a>
            }
            @if (displayOrganizationsMenu) {
                <a
                    class="application-menu-item"
                    matTooltip="Organisations enfants"
                    matTooltipPosition="right"
                    routerLink="/organizations"
                    [ngClass]="{ 'mat-list-item-visited': router.url === '/organizations', disabled: !isOrganizationSelected }">
                    <fa-icon [icon]="faCity" class="fa-icon parameters-fa-icon menu-icon" [ngClass]="{ visited: router.url === '/organizations' }"></fa-icon>
                    <span class="menu-text">Organisations enfants</span>
                </a>
            }
            @if (displayViewsMenu) {
                <a
                    class="application-menu-item"
                    matTooltip="Vues"
                    matTooltipPosition="right"
                    routerLink="/views"
                    [ngClass]="{ 'mat-list-item-visited': router.url === '/views', disabled: !isOrganizationSelected }">
                    <fa-icon [icon]="faViews" class="fa-icon parameters-fa-icon menu-icon" [ngClass]="{ visited: router.url === '/views' }"></fa-icon>
                    <span class="menu-text">Vues</span>
                </a>
            }
            @if (displayGroupUserMenu) {
                <a
                    class="application-menu-item"
                    matTooltip="Groupes d'utilisateurs"
                    matTooltipPosition="right"
                    routerLink="/groups"
                    [ngClass]="{ 'mat-list-item-visited': router.url === '/groups', disabled: !isOrganizationSelected }">
                    <fa-icon [icon]="faUsers" class="fa-icon parameters-fa-icon menu-icon" [ngClass]="{ visited: router.url === '/groups' }"></fa-icon>
                    <span class="menu-text">Groupes d'utilisateurs</span>
                </a>
            }
            @if (displayGroupUserMenu) {
                <a
                    class="application-menu-item"
                    matTooltip="Utilisateurs"
                    matTooltipPosition="right"
                    routerLink="/users"
                    [ngClass]="{ 'mat-list-item-visited': router.url === '/users', disabled: !isOrganizationSelected }">
                    <fa-icon [icon]="faUser" class="fa-icon parameters-fa-icon menu-icon" [ngClass]="{ visited: router.url === '/users' }"></fa-icon>
                    <span class="menu-text">Utilisateurs</span>
                </a>
            }
            @if (displayApplicationMenu) {
                <a
                    class="application-menu-item"
                    matTooltip="Applications"
                    matTooltipPosition="right"
                    routerLink="/applications"
                    [ngClass]="{ 'mat-list-item-visited': router.url === '/applications', disabled: !isOrganizationSelected }">
                    <fa-icon [icon]="faUser" class="fa-icon parameters-fa-icon menu-icon" [ngClass]="{ visited: router.url === '/applications' }"></fa-icon>
                    <span class="menu-text">Applications</span>
                </a>
            }
            @if (displayRoleMenu) {
                <a
                    class="application-menu-item"
                    matTooltip="Rôles"
                    matTooltipPosition="right"
                    routerLink="/roles"
                    [ngClass]="{ 'mat-list-item-visited': router.url === '/roles', disabled: !isOrganizationSelected }">
                    <fa-icon [icon]="roleIcon" class="fa-icon parameters-fa-icon menu-icon" [ngClass]="{ visited: router.url === '/roles' }"></fa-icon>
                    <span class="menu-text">Rôles</span>
                </a>
            }
            @if (displayEmailTemplateMenu) {
                <a
                    class="application-menu-item"
                    matTooltip="Modèles de mails globaux à l'organisation"
                    matTooltipPosition="right"
                    routerLink="/emailsTemplates"
                    [ngClass]="{ 'mat-list-item-visited': router.url === '/emailsTemplates', disabled: !isOrganizationSelected }">
                    <fa-icon [icon]="faEmailsTemplates" class="fa-icon parameters-fa-icon menu-icon" [ngClass]="{ visited: router.url === '/emailsTemplates' }"></fa-icon>
                    <span class="menu-text">Modèles de mails</span>
                </a>
            }

            @if (displaySmsTemplateMenu) {
                <a
                    class="application-menu-item"
                    matTooltip="Modèles de SMS globaux à l'organisation"
                    matTooltipPosition="right"
                    routerLink="/smsTemplates"
                    [ngClass]="{ 'mat-list-item-visited': router.url === '/smsTemplates', disabled: !isOrganizationSelected }">
                    <fa-icon [icon]="faSmsTemplates" class="fa-icon parameters-fa-icon menu-icon" [ngClass]="{ visited: router.url === '/smsTemplates' }"></fa-icon>
                    <span class="menu-text">Modèles de SMS</span>
                </a>
            }

            @if (displayContactsMenu) {
                <a
                    class="application-menu-item"
                    matTooltip="Contacts"
                    matTooltipPosition="right"
                    routerLink="/contacts"
                    [ngClass]="{ 'mat-list-item-visited': router.url === '/contacts', disabled: !isOrganizationSelected }">
                    <fa-icon [icon]="faAddressBook" class="fa-icon parameters-fa-icon menu-icon" [ngClass]="{ visited: router.url === '/contacts' }"></fa-icon>
                    <span class="menu-text">Contacts</span>
                </a>
            }
            @if (displayEmailAddressesMenu) {
                <a
                    class="application-menu-item"
                    matTooltip="Adresses mail"
                    matTooltipPosition="right"
                    routerLink="/emailAddresses"
                    [ngClass]="{ 'mat-list-item-visited': router.url === '/emailAddresses', disabled: !isOrganizationSelected }">
                    <fa-icon [icon]="emailAddressIcon" class="fa-icon parameters-fa-icon menu-icon" [ngClass]="{ visited: router.url === '/emailAddresses' }"></fa-icon>
                    <span class="menu-text">Adresses mail</span>
                </a>
            }
            @if (displayCustomerMenu) {
                <a
                    class="application-menu-item"
                    matTooltip="Clients"
                    matTooltipPosition="right"
                    routerLink="/customers"
                    [ngClass]="{ 'mat-list-item-visited': router.url === '/customers', disabled: !isOrganizationSelected }">
                    <fa-icon [icon]="customertIcon" class="fa-icon parameters-fa-icon menu-icon" [ngClass]="{ visited: router.url === '/customers' }"></fa-icon>
                    <span class="menu-text">Clients</span>
                </a>
            }
            @if (displayDocumentTypesMenu) {
                <a
                    class="application-menu-item"
                    matTooltip="Types de documents"
                    matTooltipPosition="right"
                    routerLink="/documentTypes"
                    [ngClass]="{ 'mat-list-item-visited': router.url === '/documentTypes', disabled: !isOrganizationSelected }">
                    <fa-icon [icon]="faDocumentType" class="fa-icon parameters-fa-icon menu-icon" [ngClass]="{ visited: router.url === '/documentTypes' }"></fa-icon>
                    <span class="menu-text">Types de documents</span>
                </a>
            }
            @if (displayArticleMenu) {
                <a
                    class="application-menu-item"
                    matTooltip="Articles"
                    matTooltipPosition="right"
                    routerLink="/articles"
                    [ngClass]="{ 'mat-list-item-visited': router.url === '/articles', disabled: !isOrganizationSelected }">
                    <fa-icon [icon]="faArticle" class="fa-icon parameters-fa-icon menu-icon" [ngClass]="{ visited: router.url === '/articles' }"></fa-icon>
                    <span class="menu-text">Articles</span>
                </a>
            }
            @if (displayFolderStatesMenu) {
                <a
                    class="application-menu-item"
                    matTooltip="États des dossiers"
                    matTooltipPosition="right"
                    routerLink="/folderStates"
                    [ngClass]="{ 'mat-list-item-visited': router.url === '/folderStates', disabled: !isOrganizationSelected }">
                    <fa-icon [icon]="faFolderStates" class="fa-icon parameters-fa-icon menu-icon" [ngClass]="{ visited: router.url === '/folderStates' }"></fa-icon>
                    <span class="menu-text">États des dossiers</span>
                </a>
            }
        </div>
    </mat-expansion-panel>
    @if (displayCurrentViewsMenuGroup) {
        <mat-expansion-panel hideToggle>
            <mat-expansion-panel-header class="">Vue courante</mat-expansion-panel-header>
            <div class="application-menu">
                @if (displayBoxMenu && viewTypeSelected === ViewType.Box && !isArchivedView) {
                    <a
                        class="application-menu-item"
                        matTooltip="Groupe de bannettes"
                        matTooltipPosition="right"
                        routerLink="/boxgroups"
                        [ngClass]="{ 'mat-list-item-visited': router.url === '/boxgroups', disabled: !isOrganizationSelected || !isViewSelected }">
                        <fa-icon [icon]="boxGroupIcon" class="fa-icon parameters-fa-icon menu-icon" [ngClass]="{ visited: router.url === '/boxgroups' }"></fa-icon>
                        <span class="menu-text">Groupes de bannettes</span>
                    </a>
                    <a
                        class="application-menu-item"
                        matTooltip="Bannettes"
                        matTooltipPosition="right"
                        routerLink="/boxes"
                        [ngClass]="{ 'mat-list-item-visited': router.url === '/boxes', disabled: !isOrganizationSelected || !isViewSelected }">
                        <fa-icon [icon]="faInbox" class="fa-icon parameters-fa-icon menu-icon" [ngClass]="{ visited: router.url === '/boxes' }"></fa-icon>
                        <span class="menu-text">Bannettes</span>
                    </a>
                }
                @if (displayWorkflowsMenu && viewTypeSelected === ViewType.Workflow && !isArchivedView) {
                    <a
                        class="application-menu-item"
                        matTooltip="Workflows"
                        matTooltipPosition="right"
                        routerLink="/workflow-designer"
                        [ngClass]="{ 'mat-list-item-visited': router.url === '/workflow-designer', disabled: !isOrganizationSelected || !isViewSelected }">
                        <fa-icon [icon]="faWorkflow" class="fa-icon parameters-fa-icon menu-icon" [ngClass]="{ visited: router.url === '/workflow-designer' }"></fa-icon>
                        <span class="menu-text">Designer de Workflow</span>
                    </a>
                }
                @if (displayAttributesMenu && !isArchivedView) {
                    <a
                        class="application-menu-item"
                        matTooltip="Attributs"
                        matTooltipPosition="right"
                        routerLink="/attributes"
                        [ngClass]="{ 'mat-list-item-visited': router.url === '/attributes', disabled: !isOrganizationSelected || !isViewSelected }">
                        <fa-icon [icon]="faAttribute" class="fa-icon parameters-fa-icon menu-icon" [ngClass]="{ visited: router.url === '/attributes' }"></fa-icon>
                        <span class="menu-text">Attributs</span>
                    </a>
                }
                @if (displayBoxLayoutsMenu && (viewTypeSelected === ViewType.Box || viewTypeSelected === ViewType.ArchivingBox)) {
                    <a
                        class="application-menu-item"
                        matTooltip="Mises en page de la vue"
                        matTooltipPosition="right"
                        routerLink="/listLayoutsBoxes"
                        [ngClass]="{ 'mat-list-item-visited': router.url === '/listLayoutsBoxes', disabled: !isOrganizationSelected || !isViewSelected }">
                        <fa-icon [icon]="faListLayouts" class="fa-icon parameters-fa-icon menu-icon" [ngClass]="{ visited: router.url === '/listLayoutsBoxes' }"></fa-icon>
                        <span class="menu-text">Mise en page</span>
                    </a>
                }
                @if (displayWorkflowLayoutsMenu && (viewTypeSelected === ViewType.Workflow || viewTypeSelected === ViewType.ArchivingWorkflow)) {
                    <a
                        class="application-menu-item"
                        matTooltip="Mises en page de la vue"
                        matTooltipPosition="right"
                        routerLink="/listLayoutsWorkflows"
                        [ngClass]="{ 'mat-list-item-visited': router.url === '/listLayoutsWorkflows', disabled: !isOrganizationSelected || !isViewSelected }">
                        <fa-icon [icon]="faListLayouts" class="fa-icon parameters-fa-icon menu-icon" [ngClass]="{ visited: router.url === '/listLayoutsWorkflows' }"></fa-icon>
                        <span class="menu-text">Mise en page</span>
                    </a>
                }
                @if (displayEmailTemplateMenu && !isArchivedView) {
                    <a
                        class="application-menu-item"
                        matTooltip="Modèles de mail de la vue"
                        matTooltipPosition="right"
                        routerLink="/views/emailsTemplates"
                        [ngClass]="{ 'mat-list-item-visited': router.url === '/views/emailsTemplates', disabled: !isOrganizationSelected || !isViewSelected }">
                        <fa-icon [icon]="faEmailsTemplates" class="fa-icon parameters-fa-icon menu-icon" [ngClass]="{ visited: router.url === '/views/emailsTemplates' }"></fa-icon>
                        <span class="menu-text">Modèles de mail</span>
                    </a>
                }
                @if (displaySmsTemplateMenu && !isArchivedView) {
                    <a
                        class="application-menu-item"
                        matTooltip="Modèles de SMS de la vue"
                        matTooltipPosition="right"
                        routerLink="/views/smsTemplates"
                        [ngClass]="{ 'mat-list-item-visited': router.url === '/views/smsTemplates', disabled: !isOrganizationSelected || !isViewSelected }">
                        <fa-icon [icon]="faSmsTemplates" class="fa-icon parameters-fa-icon menu-icon" [ngClass]="{ visited: router.url === '/views/smsTemplates' }"></fa-icon>
                        <span class="menu-text">Modèles de SMS</span>
                    </a>
                }
                @if (displaychannelsMenu && !isArchivedView) {
                    <a
                        class="application-menu-item"
                        matTooltip="Canaux de réception"
                        matTooltipPosition="right"
                        routerLink="/channels"
                        [ngClass]="{ 'mat-list-item-visited': router.url === '/channels', disabled: !isOrganizationSelected || !isViewSelected }">
                        <fa-icon [icon]="faChannel" class="fa-icon parameters-fa-icon menu-icon" [ngClass]="{ visited: router.url === '/channels' }"></fa-icon>
                        <span class="menu-text">Canaux de réception</span>
                    </a>
                }
                @if (displayProcessMenu && !isArchivedView) {
                    <a
                        class="application-menu-item"
                        matTooltip="Définition des Processus"
                        matTooltipPosition="right"
                        routerLink="/processDefinitions"
                        [ngClass]="{ 'mat-list-item-visited': router.url === '/processDefinitions', disabled: !isOrganizationSelected || !isViewSelected }">
                        <fa-icon [icon]="faChannel" class="fa-icon parameters-fa-icon menu-icon" [ngClass]="{ visited: router.url === '/processDefinitions' }"></fa-icon>
                        <span class="menu-text">Processus</span>
                    </a>
                }
                @if (displayApiConfigurationsMenu && !isArchivedView) {
                    <a
                        class="application-menu-item"
                        matTooltip="Configurations des APIs"
                        matTooltipPosition="right"
                        routerLink="/apiConfigurations"
                        [ngClass]="{ 'mat-list-item-visited': router.url === '/apiConfigurations', disabled: !isOrganizationSelected || !isViewSelected }">
                        <fa-icon [icon]="apiConfigurationIcon" class="fa-icon parameters-fa-icon menu-icon" [ngClass]="{ visited: router.url === '/apiConfigurations' }"></fa-icon>
                        <span class="menu-text">Configurations des APIs</span>
                    </a>
                }
                @if (displayFolderTrackingCustomizationMenu && viewTypeSelected === ViewType.Workflow && !isArchivedView) {
                    <a
                        class="application-menu-item"
                        matTooltip="Personnalisation du suivi de dossier"
                        matTooltipPosition="right"
                        routerLink="/folderTrackingCustomization"
                        [ngClass]="{ 'mat-list-item-visited': router.url === '/folderTrackingCustomization', disabled: !isOrganizationSelected || !isViewSelected }">
                        <fa-icon
                            [icon]="folderTrackingCustomizationIcon"
                            class="fa-icon menu-icon"
                            [ngClass]="{ visited: router.url === '/folderTrackingCustomization' }"></fa-icon>
                        <span class="menu-text">Personnalisation du suivi de dossier</span>
                    </a>
                }
            </div>
        </mat-expansion-panel>
    }
</mat-accordion>
